<template>
  <v-container
    id="customers-view"
    fluid
    tag="section"
  >
    <material-card dark icon="mdi-clipboard-text" icon-small :title="$t('roadmap_items')" color="accent">
      <template v-slot:headActions>
        <app-btn color="primary" dark class="ml-2" to="/settings/landing/roadmap/new">
          {{ $t('new_item') }}
        </app-btn>
      </template>
      <v-data-table :headers="headers" :loading="loading" :items="items">
        <template v-slot:body="{ items }">
          <item v-for="item in items" :key="item.id" :item="item" @removed="removeItem" />
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import Item from '@/components/Settings/Landing/Roadmap/Item'

export default {
  name: 'RoadmapItems',
  components: {
    Item,
  },
  data: () => ({
    loading: false,
    headers: [
      { text: 'ID', align: 'center', width: '20%', value: 'id' },
      { text: 'Title', align: 'center', width: '20%', value: 'title' },
      { text: 'Language', align: 'center', width: '20%', value: 'language' },
      { text: 'Date', align: 'center', width: '20%', value: 'date' },
      { text: 'Action', align: 'center', width: '20%', sortable: false, value: '' },
    ],
    items: [],
  }),
  mounted () {
    this.loading = true
    this.loadRoadmapItems()
      .then(result => {
        this.items = result.data
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    ...mapActions({
      loadRoadmapItems: 'settings/landing/roadmap/loadRoadmapItems',
    }),
    removeItem (itemId) {
      const idx = this.items.findIndex(i => i.id === itemId)
      this.items.splice(idx, 1)
    },
  },
}
</script>
